export type LogLevel = 'debug' | 'error' | 'cursor' | 'info';

const STYLES: Record<LogLevel, string> = {
  debug: 'color: yellow',
  error: 'color: red',
  cursor: 'color: lime',
  info: 'color: white',
};

const BASE_STYLE =
  "background: black; font-size: 12pt; padding: 4px; font-family: 'Courier New'";

/** Levels that are noise outside development and get dropped in a build. */
const VERBOSE_LEVELS: readonly LogLevel[] = ['debug', 'cursor'];

/**
 * `verbose` is a parameter rather than a direct `import.meta.env.DEV` read so
 * that both sides of the filter are reachable from tests — Vitest always runs
 * with DEV set, which would otherwise leave the production path unasserted.
 */
export function log(
  message: string,
  level: LogLevel = 'info',
  verbose: boolean = import.meta.env.DEV,
): void {
  if (VERBOSE_LEVELS.includes(level) && !verbose) {
    return;
  }
  const write = level === 'error' ? console.error : console.log;
  write(`%c ${level}> ${message}`, `${STYLES[level]}; ${BASE_STYLE}`);
}
